export const FOUNDING_CIRCLE = { total: 100, reserved: 11 } as const
export const FOUNDING_ARCHIVE_EPOCH = 2030
